import React from 'react';
import { useChatbot } from '../../context/ChatbotContext';
import { ConversationsTab } from '../../components/chatbot/tabs/ConversationsTab';

const ChatbotMessagesPage: React.FC = () => {
  const { account } = useChatbot();
  return (
    <div className="h-full -m-6">
      <ConversationsTab accountId={account.platform_id} />
    </div>
  );
};

export default ChatbotMessagesPage;
